<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    let style = document.createElement('link');
    style.type = "text/css";
    style.rel = "stylesheet";
    style.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&family=Lakki+Reddy&family=Lobster&family=Lobster+Two&family=Parisienne&family=Tangerine&display=swap';
    document.head.appendChild(style);

    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
}
</script>

<style lang="scss">
/* Import Font Awesome Icons Set */
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome.scss';
/* Import Bootstrap Vue Styles */
//@import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>



// WEBPACK FOOTER //
// src/App.vue